export const basicPopoverSubTitle = [
    {
        text: 'To set popover use the',
        code: " data-bs-toggle='popover'."
    }
];

export const popoverDirectionSubTitle = [
    {
        text: 'To set the position of popover use the',
        code: " data-bs-placement='top/bottom/...'."
    }
];

export const popoverOffsetSubTitle = [
    {
        text: 'To add the offset for popover using',
        code: ' data-bs-offset="*".'
    }
];

export const basicPopoverData = [
    {
        id: '1',
        placement: 'bottom',
        popoverHeader: 'Hover Popover',
        popoverBody: ' Several utility instruction sets have been featured in the Bootstrap 4 to promote very easy learning for beginners in the business of web building.',
        btnColor: 'success',
        btnText: 'Hover tooltip',
        trigger: 'hover'
    },
    {
        id: '2',
        size: 'lg',
        placement: 'right',
        popoverHeader: 'Dismissible popover',
        popoverBody: 'You are able to even develop and suggest improvements to the Bootstrap 4 before its final version is delivered.',
        btnColor: 'secondary',
        btnText: 'Dismissible popover',
        trigger: 'focus'
    },
]

export const popoverPositions = [
    {
        id: '3',
        placement: 'right',
        popoverHeader: 'Popover On Right',
        popoverBody: 'Popovers are opt-in for effectiveness causes, in this way you have to initialize them yourself.',
        btnColor: 'danger',
        btnText: 'Popover on right',
        trigger: 'click',
    },
    {
        id: '4',
        btnClass: 'text-light',
        placement: 'bottom',
        popoverHeader: 'Popover On Bottom',
        popoverBody: 'Identify container:to evade rendering problems in more complex components (like Bootstrap input groups, button groups, etc).',
        btnColor: 'info',
        btnText: 'Popover on bottom',
        trigger: 'click',
    },
    {
        id: '5',
        placement: 'left',
        popoverHeader: 'Popover On Left',
        popoverBody: 'Popovers are opt-in for effectiveness causes, in this way you have to initialize them yourself.',
        btnColor: 'dark',
        btnText: 'Popover on left',
        trigger: 'click',
    }
]